import React, { useEffect, useState } from 'react'
import Next from '@toasttab/shared/src/components/atoms/Controls/Directional/Next'
import Previous from '@toasttab/shared/src/components/atoms/Controls/Directional/Previous'
import { SliderNavigationProps } from './SliderNavigation.d'

const SliderNavigation = ({
  classes = '',
  previousNextButtons = 'null',
  swiper
}: SliderNavigationProps) => {
  const navVariation =
    previousNextButtons === 'slide-nav-blue-75-inverse'
      ? 'secondary'
      : 'primary'
  const [disabledPrev, setDisabledPrev] = useState<boolean>(false)
  const [disabledNext, setDisabledNext] = useState<boolean>(false)

  useEffect(() => {
    if (swiper && !swiper.params.loop) {
      swiper.on('init', () => {
        setDisabledPrev(true)
        setDisabledNext(false)
      })
      swiper.on('slideChange', () => {
        if (swiper.isBeginning) {
          setDisabledPrev(true)
          setDisabledNext(false)
        }
        if (swiper.isEnd) {
          setDisabledPrev(false)
          setDisabledNext(true)
        }
        if (!swiper.isEnd && !swiper.isBeginning) {
          setDisabledPrev(false)
          setDisabledNext(false)
        }
      })
    }
  }, [swiper])

  return (
    <div
      className={`swiper-navigation justify-end mr-0.5 !h-12 ${previousNextButtons} ${classes}`}
      data-testid='SliderNavigation'
    >
      <button className='swiper-button-prev !relative !left-[unset] !right-[unset] mr-4 !h-12 !w-12'>
        <Previous disabled={disabledPrev} variation={navVariation} />
      </button>
      <button className='swiper-button-next !relative !left-[unset] !right-[unset] !h-12 !w-12'>
        <Next disabled={disabledNext} variation={navVariation} />
      </button>
    </div>
  )
}

export default SliderNavigation
